__turbopack_context__.v({
  "alignLeft": "ChooseActivity-module__bH6W6W__alignLeft",
  "card": "ChooseActivity-module__bH6W6W__card",
  "cardBody": "ChooseActivity-module__bH6W6W__cardBody",
  "cardImage": "ChooseActivity-module__bH6W6W__cardImage",
  "cardTitle": "ChooseActivity-module__bH6W6W__cardTitle",
  "catIcon": "ChooseActivity-module__bH6W6W__catIcon",
  "catIconImg": "ChooseActivity-module__bH6W6W__catIconImg",
  "categoryArrow": "ChooseActivity-module__bH6W6W__categoryArrow",
  "categoryItem": "ChooseActivity-module__bH6W6W__categoryItem",
  "categoryItemActive": "ChooseActivity-module__bH6W6W__categoryItemActive",
  "categoryItemLeft": "ChooseActivity-module__bH6W6W__categoryItemLeft",
  "categoryLabel": "ChooseActivity-module__bH6W6W__categoryLabel",
  "categoryList": "ChooseActivity-module__bH6W6W__categoryList",
  "categoryScroll": "ChooseActivity-module__bH6W6W__categoryScroll",
  "divider": "ChooseActivity-module__bH6W6W__divider",
  "dot": "ChooseActivity-module__bH6W6W__dot",
  "dotActive": "ChooseActivity-module__bH6W6W__dotActive",
  "dots": "ChooseActivity-module__bH6W6W__dots",
  "header": "ChooseActivity-module__bH6W6W__header",
  "headingBlock": "ChooseActivity-module__bH6W6W__headingBlock",
  "headingDesktop": "ChooseActivity-module__bH6W6W__headingDesktop",
  "headingMobile": "ChooseActivity-module__bH6W6W__headingMobile",
  "imageWrap": "ChooseActivity-module__bH6W6W__imageWrap",
  "layout": "ChooseActivity-module__bH6W6W__layout",
  "main": "ChooseActivity-module__bH6W6W__main",
  "priceDesktop": "ChooseActivity-module__bH6W6W__priceDesktop",
  "priceLabel": "ChooseActivity-module__bH6W6W__priceLabel",
  "priceMobile": "ChooseActivity-module__bH6W6W__priceMobile",
  "priceValue": "ChooseActivity-module__bH6W6W__priceValue",
  "regionSelect": "ChooseActivity-module__bH6W6W__regionSelect",
  "section": "ChooseActivity-module__bH6W6W__section",
  "selectWrap": "ChooseActivity-module__bH6W6W__selectWrap",
  "sidebar": "ChooseActivity-module__bH6W6W__sidebar",
  "slickSlide": "ChooseActivity-module__bH6W6W__slickSlide",
  "slickWrap": "ChooseActivity-module__bH6W6W__slickWrap",
  "slider": "ChooseActivity-module__bH6W6W__slider",
  "srOnly": "ChooseActivity-module__bH6W6W__srOnly",
});
